import { createSlice } from '@reduxjs/toolkit';

const registerVerification = createSlice({
  name: 'verification',
  initialState: {
    verify: null,
  },
  reducers: {
    setVerification: (state, action) => {
      state.verify = action.payload;
    },
    clearVerification: (state) => {
      state.verify = null;
    },
  },
});

export const { setVerification, clearVerification } = registerVerification.actions;

export default registerVerification.reducer;
